import { render, staticRenderFns } from "./GratitudeJournal.vue?vue&type=template&id=a876b762&scoped=true"
import script from "./GratitudeJournal.vue?vue&type=script&lang=js"
export * from "./GratitudeJournal.vue?vue&type=script&lang=js"
import style0 from "./GratitudeJournal.vue?vue&type=style&index=0&id=a876b762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a876b762",
  null
  
)

export default component.exports